// extracted by mini-css-extract-plugin
export default {"header":"verify-email_header__AMgne header","tip-box":"verify-email_tip-box__HGzU6","button-row":"verify-email_button-row__RLK93 form-button-row"};